
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Appointment"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"locationAddress"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"appointmentBegin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"appointmentEnd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"apiConnected"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emailRemindersDisabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasFollowUps"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"followUpsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nextFollowUpDueAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"patient"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"office"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointmentReminders"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentReminderFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"informationClarification"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InformationClarificationFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":546}};
    doc.loc.source = {"body":"#import \"../fragments/AppointmentReminderFragment.graphql\"\n#import \"../fragments/InformationClarificationFragment.graphql\"\nfragment AppointmentFragment on Appointment {\n  id\n  name\n  locationAddress\n  appointmentBegin\n  appointmentEnd\n  apiConnected\n  emailRemindersDisabled\n  hasFollowUps\n  followUpsCount\n  nextFollowUpDueAt\n  patient {\n    firstName\n    lastName\n    id\n    office {\n      name\n    }\n  }\n  appointmentReminders {\n    ...AppointmentReminderFragment\n  }\n  informationClarification {\n    ...InformationClarificationFragment\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../fragments/AppointmentReminderFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../fragments/InformationClarificationFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["AppointmentFragment"] = oneQuery(doc, "AppointmentFragment");
        
